/**
 * Price model
 *
 * Each table has base price, which depends on the table top material type and thickness,
 * and its dimensions.
 *
 * Other properties, including legs, finish, colour, ceramic variant may add to the base
 * price depending on the option selected.
 *
 * All prices are in EUR.
 */ import { ColorOak, EdgeFinish, Legs3D, Legs3DRonde, LegsAxel, LegsBrago, LegsButterfly, LegsClassico, LegsColorSteel, LegsCono, LegsDiamond, LegsEbonu3DoubleEik, LegsEbonu3DoubleStaal, LegsEbonu3Eik, LegsEbonu3Staal, LegsEbonuEik, LegsEbonuStaal, LegsEbu, LegsElmo, LegsElmoDouble, LegsFalke, LegsFly, LegsHarper, LegsHarper3, LegsJulio3, LegsJulio4, LegsLivio, LegsLivioSchuinEik, LegsLivioSchuinStaal, LegsMPootRecht, LegsMPootSchuin, LegsMadrid, LegsNewly, LegsNovaroDoubleEik, LegsNovaroDoubleStaal, LegsNovaroEik, LegsNovaroStaal, LegsOdil3, LegsOdil4, LegsOslo, LegsOxford, LegsPapillon, LegsPapillonStrak, LegsPino, LegsRafino, LegsRobuDoubleEik, LegsRobuDoubleStaal, LegsRobuEik, LegsRobuStaal, LegsRoia, LegsTPoot, LegsTPootRonde, LegsThickness, LegsTrapezium, LegsTwist3, LegsTwist4, LegsUPoot, LegsXPoot, TopColorCeramic, TopColorFenix, TopFinish } from '../__generated/model/index.js';
/**
 * Prices as provided by the client on 13 February 2025 unless otherwise noted in the comments.
 */ export const BASE_PRICE_MAP_CIRCLE_OAK_30 = new Map([
    [
        1000,
        900
    ],
    [
        1100,
        1000
    ],
    [
        1200,
        1100
    ],
    [
        1300,
        1200
    ],
    [
        1400,
        1300
    ],
    [
        1500,
        1400
    ],
    [
        1600,
        1500
    ],
    [
        1700,
        1600
    ],
    [
        1800,
        1700
    ]
]);
export const BASE_PRICE_MAP_CIRCLE_OAK_40 = new Map([
    [
        1000,
        1100
    ],
    [
        1100,
        1200
    ],
    [
        1200,
        1300
    ],
    [
        1300,
        1400
    ],
    [
        1400,
        1500
    ],
    [
        1500,
        1600
    ],
    [
        1600,
        1700
    ],
    [
        1700,
        1800
    ],
    [
        1800,
        1900
    ]
]);
export const BASE_PRICE_MAP_CIRCLE_CERAMIC = new Map([
    [
        1000,
        1350
    ],
    [
        1100,
        1450
    ],
    [
        1200,
        1550
    ],
    [
        1300,
        1650
    ],
    [
        1350,
        1750
    ],
    [
        1400,
        1850
    ],
    [
        1500,
        1950
    ],
    [
        1600,
        2100
    ]
]);
export const BASE_PRICE_MAP_CIRCLE_FENIX_SOLID = new Map([
    [
        1000,
        1520
    ],
    [
        1100,
        1580
    ],
    [
        1200,
        1680
    ],
    [
        1300,
        1780
    ],
    [
        1350,
        2075
    ],
    [
        1400,
        2245
    ],
    [
        1500,
        2345
    ],
    [
        1580,
        2460
    ]
]);
export const BASE_PRICE_MAP_CIRCLE_FENIX_BIRCH = new Map([
    [
        1000,
        1300
    ],
    [
        1100,
        1400
    ],
    [
        1200,
        1500
    ],
    [
        1300,
        1600
    ],
    [
        1350,
        1800
    ],
    [
        1400,
        1900
    ]
]);
export const BASE_PRICE_MAP_OTHER_OAK_30 = new Map([
    [
        1600,
        new Map([
            [
                800,
                1300
            ],
            [
                900,
                1350
            ],
            [
                1000,
                1400
            ],
            [
                1100,
                1450
            ],
            [
                1200,
                1500
            ],
            [
                1300,
                1550
            ]
        ])
    ],
    [
        1800,
        new Map([
            [
                800,
                1400
            ],
            [
                900,
                1450
            ],
            [
                1000,
                1500
            ],
            [
                1100,
                1550
            ],
            [
                1200,
                1600
            ],
            [
                1300,
                1650
            ]
        ])
    ],
    [
        2000,
        new Map([
            [
                800,
                1500
            ],
            [
                900,
                1550
            ],
            [
                1000,
                1600
            ],
            [
                1100,
                1650
            ],
            [
                1200,
                1700
            ],
            [
                1300,
                1750
            ]
        ])
    ],
    [
        2200,
        new Map([
            [
                800,
                1600
            ],
            [
                900,
                1650
            ],
            [
                1000,
                1700
            ],
            [
                1100,
                1750
            ],
            [
                1200,
                1800
            ],
            [
                1300,
                1850
            ]
        ])
    ],
    [
        2400,
        new Map([
            [
                800,
                1700
            ],
            [
                900,
                1750
            ],
            [
                1000,
                1800
            ],
            [
                1100,
                1850
            ],
            [
                1200,
                1900
            ],
            [
                1300,
                1950
            ]
        ])
    ],
    [
        2600,
        new Map([
            [
                800,
                1800
            ],
            [
                900,
                1850
            ],
            [
                1000,
                1900
            ],
            [
                1100,
                1950
            ],
            [
                1200,
                2000
            ],
            [
                1300,
                2050
            ]
        ])
    ],
    [
        2800,
        new Map([
            [
                800,
                1900
            ],
            [
                900,
                1950
            ],
            [
                1000,
                2000
            ],
            [
                1100,
                2050
            ],
            [
                1200,
                2100
            ],
            [
                1300,
                2150
            ]
        ])
    ],
    [
        3000,
        new Map([
            [
                800,
                2000
            ],
            [
                900,
                2050
            ],
            [
                1000,
                2100
            ],
            [
                1100,
                2150
            ],
            [
                1200,
                2200
            ],
            [
                1300,
                2250
            ]
        ])
    ]
]);
export const BASE_PRICE_MAP_OTHER_OAK_40 = new Map([
    [
        1600,
        new Map([
            [
                800,
                1600
            ],
            [
                900,
                1650
            ],
            [
                1000,
                1700
            ],
            [
                1100,
                1750
            ],
            [
                1200,
                1800
            ],
            [
                1300,
                1850
            ]
        ])
    ],
    [
        1800,
        new Map([
            [
                800,
                1800
            ],
            [
                900,
                1850
            ],
            [
                1000,
                1900
            ],
            [
                1100,
                1950
            ],
            [
                1200,
                2000
            ],
            [
                1300,
                2050
            ]
        ])
    ],
    [
        2000,
        new Map([
            [
                800,
                2050
            ],
            [
                900,
                2100
            ],
            [
                1000,
                2150
            ],
            [
                1100,
                2200
            ],
            [
                1200,
                2250
            ],
            [
                1300,
                2300
            ]
        ])
    ],
    [
        2200,
        new Map([
            [
                800,
                2150
            ],
            [
                900,
                2200
            ],
            [
                1000,
                2250
            ],
            [
                1100,
                2300
            ],
            [
                1200,
                2350
            ],
            [
                1300,
                2400
            ]
        ])
    ],
    [
        2400,
        new Map([
            [
                800,
                2250
            ],
            [
                900,
                2300
            ],
            [
                1000,
                2350
            ],
            [
                1100,
                2400
            ],
            [
                1200,
                2450
            ],
            [
                1300,
                2500
            ]
        ])
    ],
    [
        2600,
        new Map([
            [
                800,
                2350
            ],
            [
                900,
                2400
            ],
            [
                1000,
                2450
            ],
            [
                1100,
                2500
            ],
            [
                1200,
                2550
            ],
            [
                1300,
                2600
            ]
        ])
    ],
    [
        2800,
        new Map([
            [
                800,
                2450
            ],
            [
                900,
                2500
            ],
            [
                1000,
                2550
            ],
            [
                1100,
                2600
            ],
            [
                1200,
                2650
            ],
            [
                1300,
                2700
            ]
        ])
    ],
    [
        3000,
        new Map([
            [
                800,
                2550
            ],
            [
                900,
                2600
            ],
            [
                1000,
                2650
            ],
            [
                1100,
                2700
            ],
            [
                1200,
                2750
            ],
            [
                1300,
                2800
            ]
        ])
    ]
]);
export const BASE_PRICE_MAP_OTHER_CERAMIC = new Map([
    [
        1600,
        new Map([
            [
                800,
                1590
            ],
            [
                900,
                1640
            ],
            [
                1000,
                1690
            ],
            [
                1100,
                1740
            ],
            [
                1200,
                1790
            ],
            [
                1300,
                1840
            ]
        ])
    ],
    [
        1800,
        new Map([
            [
                800,
                1700
            ],
            [
                900,
                1750
            ],
            [
                1000,
                1800
            ],
            [
                1100,
                1850
            ],
            [
                1200,
                1900
            ],
            [
                1300,
                1950
            ]
        ])
    ],
    [
        2000,
        new Map([
            [
                800,
                1800
            ],
            [
                900,
                1850
            ],
            [
                1000,
                1890
            ],
            [
                1100,
                1930
            ],
            [
                1200,
                1980
            ],
            [
                1300,
                2030
            ]
        ])
    ],
    [
        2200,
        new Map([
            [
                800,
                1900
            ],
            [
                900,
                1950
            ],
            [
                1000,
                2000
            ],
            [
                1100,
                2040
            ],
            [
                1200,
                2090
            ],
            [
                1300,
                2150
            ]
        ])
    ],
    [
        2400,
        new Map([
            [
                800,
                2050
            ],
            [
                900,
                2100
            ],
            [
                1000,
                2150
            ],
            [
                1100,
                2200
            ],
            [
                1200,
                2250
            ],
            [
                1300,
                2300
            ]
        ])
    ],
    [
        2600,
        new Map([
            [
                800,
                2200
            ],
            [
                900,
                2250
            ],
            [
                1000,
                2300
            ],
            [
                1100,
                2350
            ],
            [
                1200,
                2400
            ],
            [
                1300,
                2450
            ]
        ])
    ],
    [
        2800,
        new Map([
            [
                800,
                2350
            ],
            [
                900,
                2400
            ],
            [
                1000,
                2450
            ],
            [
                1100,
                2500
            ],
            [
                1200,
                2550
            ],
            [
                1300,
                2600
            ]
        ])
    ],
    [
        3000,
        new Map([
            [
                800,
                2450
            ],
            [
                900,
                2500
            ],
            [
                1000,
                2550
            ],
            [
                1100,
                2600
            ],
            [
                1200,
                2650
            ],
            [
                1300,
                2700
            ]
        ])
    ]
]);
export const BASE_PRICE_MAP_OTHER_FENIX_SOLID = new Map([
    [
        1600,
        new Map([
            [
                800,
                1850
            ],
            [
                900,
                1900
            ],
            [
                1000,
                1950
            ],
            [
                1100,
                2000
            ],
            [
                1200,
                2050
            ],
            [
                1300,
                2100
            ]
        ])
    ],
    [
        1800,
        new Map([
            [
                800,
                1950
            ],
            [
                900,
                2000
            ],
            [
                1000,
                2050
            ],
            [
                1100,
                2100
            ],
            [
                1200,
                2150
            ],
            [
                1300,
                2200
            ]
        ])
    ],
    [
        2000,
        new Map([
            [
                800,
                2000
            ],
            [
                900,
                2050
            ],
            [
                1000,
                2100
            ],
            [
                1100,
                2150
            ],
            [
                1200,
                2200
            ],
            [
                1300,
                2250
            ]
        ])
    ],
    [
        2200,
        new Map([
            [
                800,
                2150
            ],
            [
                900,
                2200
            ],
            [
                1000,
                2250
            ],
            [
                1100,
                2300
            ],
            [
                1200,
                2350
            ],
            [
                1300,
                2400
            ]
        ])
    ],
    [
        2400,
        new Map([
            [
                800,
                2250
            ],
            [
                900,
                2300
            ],
            [
                1000,
                2350
            ],
            [
                1100,
                2400
            ],
            [
                1200,
                2450
            ],
            [
                1300,
                2500
            ]
        ])
    ],
    [
        2600,
        new Map([
            [
                800,
                2350
            ],
            [
                900,
                2400
            ],
            [
                1000,
                2450
            ],
            [
                1100,
                2500
            ],
            [
                1200,
                2550
            ],
            [
                1300,
                2600
            ]
        ])
    ],
    [
        2800,
        new Map([
            [
                800,
                2500
            ],
            [
                900,
                2550
            ],
            [
                1000,
                2600
            ],
            [
                1100,
                2650
            ],
            [
                1200,
                2700
            ],
            [
                1300,
                2750
            ]
        ])
    ],
    [
        3000,
        new Map([
            [
                800,
                2600
            ],
            [
                900,
                2650
            ],
            [
                1000,
                2700
            ],
            [
                1100,
                2750
            ],
            [
                1200,
                2800
            ],
            [
                1300,
                2850
            ]
        ])
    ]
]);
export const BASE_PRICE_MAP_OTHER_FENIX_BIRCH = new Map([
    [
        1600,
        new Map([
            [
                800,
                1700
            ],
            [
                900,
                1750
            ],
            [
                1000,
                1800
            ],
            [
                1100,
                1850
            ],
            [
                1200,
                1900
            ],
            [
                1300,
                1950
            ]
        ])
    ],
    [
        1800,
        new Map([
            [
                800,
                1800
            ],
            [
                900,
                1850
            ],
            [
                1000,
                1900
            ],
            [
                1100,
                1950
            ],
            [
                1200,
                2000
            ],
            [
                1300,
                2050
            ]
        ])
    ],
    [
        2000,
        new Map([
            [
                800,
                1850
            ],
            [
                900,
                1900
            ],
            [
                1000,
                1950
            ],
            [
                1100,
                2000
            ],
            [
                1200,
                2050
            ],
            [
                1300,
                2100
            ]
        ])
    ],
    [
        2200,
        new Map([
            [
                800,
                2000
            ],
            [
                900,
                2050
            ],
            [
                1000,
                2100
            ],
            [
                1100,
                2150
            ],
            [
                1200,
                2200
            ],
            [
                1300,
                2250
            ]
        ])
    ],
    [
        2400,
        new Map([
            [
                800,
                2100
            ],
            [
                900,
                2150
            ],
            [
                1000,
                2200
            ],
            [
                1100,
                2250
            ],
            [
                1200,
                2300
            ],
            [
                1300,
                2350
            ]
        ])
    ],
    [
        2600,
        new Map([
            [
                800,
                2200
            ],
            [
                900,
                2250
            ],
            [
                1000,
                2300
            ],
            [
                1100,
                2350
            ],
            [
                1200,
                2400
            ],
            [
                1300,
                2450
            ]
        ])
    ],
    [
        2800,
        new Map([
            [
                800,
                2350
            ],
            [
                900,
                2400
            ],
            [
                1000,
                2450
            ],
            [
                1100,
                2500
            ],
            [
                1200,
                2550
            ],
            [
                1300,
                2600
            ]
        ])
    ],
    [
        3000,
        new Map([
            [
                800,
                2450
            ],
            [
                900,
                2500
            ],
            [
                1000,
                2550
            ],
            [
                1100,
                2600
            ],
            [
                1200,
                2650
            ],
            [
                1300,
                2700
            ]
        ])
    ]
]);
export const LEGS_PRICE_MAP = {
    [Legs3D.type]: 0,
    [LegsAxel.type]: 0,
    [LegsBrago.type]: 150,
    [LegsButterfly.type]: 0,
    [LegsClassico.type]: 0,
    [LegsCono.type]: 300,
    [LegsDiamond.type]: 250,
    [LegsEbonuEik.type]: 500,
    [LegsEbonuStaal.type]: 0,
    [LegsEbonu3Eik.type]: 500,
    [LegsEbonu3Staal.type]: 0,
    [LegsEbonu3DoubleEik.type]: 500,
    [LegsEbonu3DoubleStaal.type]: 500,
    [LegsEbu.type]: 0,
    [LegsElmo.type]: 500,
    [LegsElmoDouble.type]: 500,
    [LegsFalke.type]: 0,
    [LegsFly.type]: 0,
    [LegsHarper.type]: 0,
    [LegsHarper3.type]: 0,
    [LegsJulio3.type]: 0,
    [LegsJulio4.type]: 0,
    [LegsLivio.type]: 700,
    [LegsLivioSchuinEik.type]: 700,
    [LegsLivioSchuinStaal.type]: 250,
    [LegsMPootSchuin.type]: 0,
    [LegsMadrid.type]: 0,
    [LegsNewly.type]: 0,
    [LegsNovaroEik.type]: 500,
    [LegsNovaroStaal.type]: 250,
    [LegsNovaroDoubleEik.type]: 500,
    [LegsNovaroDoubleStaal.type]: 500,
    [LegsOdil3.type]: 0,
    [LegsOdil4.type]: 0,
    [LegsOslo.type]: 250,
    [LegsOxford.type]: 0,
    [LegsPapillon.type]: 250,
    [LegsPapillonStrak.type]: 250,
    [LegsPino.type]: 0,
    [LegsRafino.type]: 0,
    [LegsRobuEik.type]: 500,
    [LegsRobuStaal.type]: 250,
    [LegsRobuDoubleEik.type]: 500,
    [LegsRobuDoubleStaal.type]: 500,
    [LegsRoia.type]: 250,
    [LegsTPoot.type]: 0,
    [LegsTPootRonde.type]: 0,
    [LegsTrapezium.type]: 0,
    [LegsTwist3.type]: 0,
    [LegsTwist4.type]: 0,
    [LegsXPoot.type]: 0
};
export const LEGS_WITH_THICKNESS_PRICE_MAP = {
    [Legs3DRonde.type]: {
        [LegsThickness.Thick]: 0,
        [LegsThickness.Thin]: 0
    },
    [LegsMPootRecht.type]: {
        [LegsThickness.Thick]: 0,
        [LegsThickness.Thin]: 0
    },
    [LegsTwist3.type]: {
        [LegsThickness.Thick]: 0,
        [LegsThickness.Thin]: 0
    },
    [LegsTwist4.type]: {
        [LegsThickness.Thick]: 0,
        [LegsThickness.Thin]: 0
    },
    [LegsUPoot.type]: {
        [LegsThickness.Thick]: 0,
        [LegsThickness.Thin]: 0
    }
};
export const CERAMIC_PRICE_MAP = {
    [TopColorCeramic.CuarzoReno]: 0,
    [TopColorCeramic.NeroZimbabwe]: 0,
    [TopColorCeramic.BiancoSupreme]: 0,
    [TopColorCeramic.CalacataVaglie]: 0,
    [TopColorCeramic.TajMahal]: 0,
    [TopColorCeramic.MacchiaVecchia]: 0,
    [TopColorCeramic.CalacataNaturel]: 0,
    [TopColorCeramic.BlueStoneNegro]: 0,
    [TopColorCeramic.CeppoDeGre]: 350,
    [TopColorCeramic.NeroArdi]: 0,
    [TopColorCeramic.PaladioNaturel]: 0,
    [TopColorCeramic.CalceGrigio]: 350,
    [TopColorCeramic.TitanCemento]: 0,
    [TopColorCeramic.LavaCorten]: 0,
    [TopColorCeramic.BasicNieve]: 350,
    [TopColorCeramic.Travertin]: 0,
    [TopColorCeramic.CalacataGold]: 0,
    [TopColorCeramic.SurfaceSand]: 0,
    [TopColorCeramic.SurfaceOffWhite]: 0,
    [TopColorCeramic.NoirDesir]: 350,
    [TopColorCeramic.SurfaceCoolGrey]: 0,
    [TopColorCeramic.HyperWhite]: 0,
    [TopColorCeramic.DarkBlack]: 0,
    [TopColorCeramic.ClassicCarrara]: 0
};
export const TOP_FINISH_PRICE_MAP_SMALL = {
    [TopFinish.None]: 0,
    [TopFinish.NewOak]: 200,
    [TopFinish.LivedOak]: 0,
    [TopFinish.RefinedOak]: 350
};
export const TOP_FINISH_PRICE_MAP_LARGE = {
    [TopFinish.None]: 0,
    [TopFinish.NewOak]: 250,
    [TopFinish.LivedOak]: 0,
    [TopFinish.RefinedOak]: 400
};
export const EDGE_FINISH_PRICE_MAP = {
    [EdgeFinish.Standard]: 0,
    [EdgeFinish.Facet]: 50,
    [EdgeFinish.Round]: 50
};
export const COLOR_OAK_PRICE_MAP = {
    [ColorOak.UltraMatteLak]: 0,
    [ColorOak.Oyster]: 0,
    [ColorOak.DarkOak]: 0,
    [ColorOak.Charcoal]: 0,
    [ColorOak.SlateGrey]: 0,
    [ColorOak.CottonWhite]: 0,
    [ColorOak.Black]: 0
};
export const TOP_COLOR_FENIX_PRICE_MAP = {
    [TopColorFenix.BiancoKos0032]: 0,
    [TopColorFenix.BeigeLuxor0719]: 0,
    [TopColorFenix.NeroIngo0720]: 0,
    [TopColorFenix.VerdeComodoro0750]: 0,
    [TopColorFenix.VerdeBrac0773]: 0
};
export const LEGS_COLOR_STEEL_PRICE_MAP = {
    [LegsColorSteel.RAL9005]: 0,
    [LegsColorSteel.RAL9016]: 0,
    [LegsColorSteel.AnodicGold]: 75,
    [LegsColorSteel.AnodicBronze]: 75,
    [LegsColorSteel.AnodicBrown]: 75
};

//# sourceMappingURL=prices.js.map